import apiConfig from "../../apiConfig";

export const setAgentStatus = async (at, agentId, statusId) => {
	const response = await apiConfig.post(
		"/API/CHARITY/LOOKUPS/AGENTS/Set_Agent_Status",
		{
			Agent_Id: agentId,
			Active_Status_Id: statusId,
		},
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	return response.data;
};
